import {SearchOptionsRequest} from '../../../../../shared/models/SearchOptionsRequest.model';
import {UnitPaymentCategory} from '../models/unit-payment-category.enum';

export class PaymentSearchOptionsDto extends SearchOptionsRequest {
  category: UnitPaymentCategory;
  recipientId: number;
  fromDate: string;
  toDate: string;
}
